<!-- 基本组件 公司组件 产品组件 -->
<template>
    <div>
        <div class="card">
            <div class="flex-sb">
                <span class="title">基础组件</span>
                <Icon type="ios-arrow-up" size="20" color="#484E66" />
            </div>
            <div class="flex-sb flex-w">
                <div class="card-btn" @click="menuClick(1)">
                    <img class="mr-12" src="@/assets/diy/image.png" />
                    <div>图文导航</div>
                </div>
                <div class="card-btn" @click="menuClick(2)">
                    <img class="mr-12" src="@/assets/diy/advertisement.png" />
                    <div>轮播广告</div>
                </div>
                <div class="card-btn" @click="menuClick(3)">
                    <img class="mr-12" src="@/assets/diy/notice.png" />
                    <div>公告</div>
                </div>
                <div class="card-btn" @click="menuClick(4)">
                    <img class="mr-12" src="@/assets/diy/company_image.png" />
                    <div>标题</div>
                </div>
                <div class="card-btn" @click="menuClick(5)">
                    <img
                        class="mr-12"
                        src="@/assets/diy/image_advertisement.png"
                    />
                    <div>图片广告</div>
                </div>
                <div class="card-btn" @click="menuClick(6)">
                    <img class="mr-12" src="@/assets/diy/video.png" />
                    <div>视频</div>
                </div>
                <div class="card-btn" @click="menuClick(7)">
                    <img class="mr-12" src="@/assets/diy/article_list.png" />
                    <div>文章列表</div>
                </div>
                <div class="card-btn" @click="menuClick(8)">
                    <img class="mr-12" src="@/assets/diy/image_details.png" />
                    <div>图文详情</div>
                </div>
                <div class="card-btn" @click="getPop">
                    <img class="mr-12" src="@/assets/diy/advertisement2.png" />
                    <div>弹窗组件</div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="flex-sb">
                <span class="title">公司组件</span>
                <Icon type="ios-arrow-up" size="20" color="#484E66" />
            </div>
            <div class="flex-sb flex-w">
                <div class="card-btn" @click="menuClick(9)">
                    <img class="mr-12" src="@/assets/diy/image.png" />
                    <div>营业执照</div>
                </div>
                <div class="card-btn" @click="menuClick(10)">
                    <img class="mr-12" src="@/assets/diy/other.png" />
                    <div>其他资质</div>
                </div>
                <div class="card-btn" @click="menuClick(11)">
                    <img
                        class="mr-12"
                        src="@/assets/diy/image_advertisement.png"
                    />
                    <div>公司图片</div>
                </div>
                <div class="card-btn" @click="menuClick(12)">
                    <img class="mr-12" src="@/assets/diy/notice.png" />
                    <div>公司信息</div>
                </div>
                <div class="card-btn" v-if="diy_id == 1 || diy_id == 3" @click="menuClick(20)">
                    <img class="mr-12" src="@/assets/diy/agent.png" />
                    <div>代理商信息</div>
                </div>
            </div>
        </div>
        <div class="card" v-if="diy_id == 1 || diy_id == 3">
            <div class="flex-sb">
                <span class="title">产品组件</span>
                <Icon type="ios-arrow-up" size="20" color="#484E66" />
            </div>
            <div class="flex-sb flex-w">
                <div class="card-btn" @click="menuClick(13)">
                    <img class="mr-12" src="@/assets/diy/attribute.png" />
                    <div>产品属性</div>
                </div>
                <div class="card-btn" @click="menuClick(14)">
                    <img class="mr-12" src="@/assets/diy/brochure.png" />
                    <div>产品样册</div>
                </div>
                <div class="card-btn" @click="menuClick(15)">
                    <img class="mr-12" src="@/assets/diy/report.png" />
                    <div>质检报告</div>
                </div>
                <div class="card-btn" @click="menuClick(16)">
                    <img class="mr-12" src="@/assets/diy/node.png" />
                    <div>实例节点</div>
                </div>
                <div class="card-btn" @click="menuClick(17)">
                    <img class="mr-12" src="@/assets/diy/result.png" />
                    <div>查询结果</div>
                </div>
                <div class="card-btn" @click="menuClick(18)">
                    <img class="mr-12" src="@/assets/diy/product_info.png" />
                    <div>产品信息</div>
                </div>
                <div class="card-btn" @click="menuClick(19)">
                    <img class="mr-12" src="@/assets/diy/product_img.png" />
                    <div>产品图片</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        diy_id: {
            type: String,
            default: "0",
        },
        formData: {
            type: Array,
            default: [],
        },
        popData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        getPop() {
            var value;
            value = this.formData.some((item) => item.type == 21);
            if (!value) {
                this.formData.splice(1, 0, this.popData);
            }
        },
        // 左侧菜单点击
        menuClick(e) {
            switch (e) {
                case 1:
                    this.formData.push({
                        type: 1,
                        name: "图文导航",
                        content: {
                            width: 50,
                            height: 50,
                            bg_color: "#FFFFFF",
                            text_color: "#333333",
                            type_id: 1, //导航样式
                            iconList: [
                                {
                                    value: "/icon/diys/smail.png",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                    title: "标题",
                                    describe: "功能描述",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                },
                                {
                                    value: "/icon/diys/smail.png",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                    title: "标题",
                                    describe: "功能描述",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                },
                                {
                                    value: "/icon/diys/smail.png",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                    title: "标题",
                                    describe: "功能描述",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                },
                            ],
                            marginData: {
                                top: 12,
                                left: 12,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 2:
                    this.formData.push({
                        type: 2,
                        name: "轮播广告",
                        content: {
                            autoplay: "0",
                            time: 0,
                            height_id: 1, //长宽比例
                            bannerList: [
                                {
                                    value: "/icon/diys/banner.png",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/banner.png",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                },
                            ],
                            marginData: {
                                top: 0,
                                left: 0,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 3:
                    this.formData.push({
                        type: 3,
                        name: "公告",
                        content: {
                            text: "公告内容公告内容公告内容",
                            size: "14",
                            text_color: "#333333",
                            bg_color: "#FFFFFF",
                            title: "公告名称",
                            rollValue: 1,
                            rollSpeed: 100,
                            imgs: {
                                value: "/icon/diys/notice.png",
                                picview:
                                    "https://suyuan.hulianzaowu.com/icon/diys/notice.png",
                            },
                        },
                    });
                    break;
                case 4:
                    this.formData.push({
                        type: 4,
                        name: "标题",
                        content: {
                            text: "标题标题标题",
                            size: "20",
                            position: "left",
                            text_color: "#333333",
                            bg_color: "#FFFFFF",
                        },
                    });
                    break;
                case 5:
                    this.formData.push({
                        type: 5,
                        name: "图片广告",
                        content: {
                            height: 250,
                            style_id: 0, //图片样式id
                            imgList: [{ value: "", picview: "" }],
                            marginData: {
                                top: 0,
                                left: 0,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                            hotspot: [],
                        },
                    });
                    break;
                case 6:
                    this.formData.push({
                        type: 6,
                        name: "视频",
                        content: {
                            height_id: 1,
                            loop: 0,
                            autoplay: "0",
                            bg_color: "#FFFFFF",
                            videoList: {
                                value: "/unidoc/zh/2minute-demo.mp4",
                                picview:
                                    "https://qiniu-web-assets.dcloud.net.cn/unidoc/zh/2minute-demo.mp4",
                            },
                            marginData: {
                                top: 0,
                                left: 0,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 7:
                    this.formData.push({
                        type: 7,
                        name: "文章列表",
                        content: {
                            title: "大标题",
                            big_title_color: "#23313F",
                            title_color: "#23313F",
                            text: "文章内容文章内容文章内容",
                            text_color: "#9FA5BB",
                            time_value: 0,
                            time_color: "#FFFFFF",
                            bg_color: "#FFFFFF",
                            marginData: {
                                top: 12,
                                left: 12,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                            articleData: {
                                content: "内容",
                                title: "标题",
                                created_at: "2025-01-01",
                            },
                        },
                        articleData: [
                            {
                                id: "",
                                content: "内容",
                                title: "标题",
                                created_at: "2025-01-01",
                            },
                        ],
                    });
                    break;
                case 8:
                    this.formData.push({
                        type: 8,
                        name: "图文详情",
                        content: {
                            text: "图文详情内容",
                            bg_color: "#FFFFFF",
                            marginData: {
                                top: 0,
                                left: 0,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 9:
                    this.formData.push({
                        type: 9,
                        name: "营业执照",
                        content: {
                            height_id: 1,
                            bg_color: "#fff",
                            marginData: {
                                top: 0,
                                left: 0,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 10:
                    this.formData.push({
                        type: 10,
                        name: "其他资质",
                        content: {
                            height_id: 1,
                            value: 0,
                            style_id: 0,
                            autoplay: "0",
                            bg_color: "#fff",
                            indicator_color: "#fff",
                            imgList: [
                                {
                                    value: "/icon/diys/banner.png",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/banner.png",
                                },
                            ],
                            marginData: {
                                top: 0,
                                left: 0,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 11:
                    this.formData.push({
                        type: 11,
                        name: "公司图片",
                        content: {
                            height_id: 1,
                            value: 0,
                            style_id: 0,
                            autoplay: "0",
                            bg_color: "#fff",
                            indicator_color: "#fff",
                            imgList: [
                                {
                                    value: "/icon/diys/banner.png",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/banner.png",
                                },
                            ],
                            marginData: {
                                top: 0,
                                left: 0,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 12:
                    this.formData.push({
                        type: 12,
                        name: "公司信息",
                        content: {
                            title_color: "#333333",
                            title_size: "14",
                            text_color: "#333333",
                            size: "14",
                            bg_color: "#FFFFFF",
                            logo: {
                                value: "/icon/diys/banner.png",
                                picview:
                                    "https://suyuan.hulianzaowu.com/icon/diys/banner.png",
                            },
                            marginData: {
                                top: 12,
                                left: 12,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 20:
                    this.formData.push({
                        type: 20,
                        name: "代理商信息",
                        content: {
                            type: ["授权编号", "手机号码", "负责区域"],
                            title_color: "#333333",
                            title_size: "18",
                            text_color: "#333333",
                            size: "14",
                            bg_color: "#FFFFFF",
                            marginData: {
                                top: 12,
                                left: 12,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 13:
                    this.formData.push({
                        type: 13,
                        name: "产品属性",
                        content: {
                            title_color: "#00AC41",
                            title_size: "18",
                            title_bg_color: "#FFFFFF",
                            text_color: "#999999",
                            text_size: "14",
                            text_bg_color: "#FFFFFF",
                            marginData: {
                                top: 12,
                                left: 12,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 14:
                    this.formData.push({
                        type: 14,
                        name: "产品样册",
                        content: {
                            height_id: 2,
                            title_color: "#00AC41",
                            title_size: "18",
                            title_bg_color: "#FFFFFF",
                            text_color: "#999999",
                            text_size: "12",
                            text_bg_color: "#FFFFFF",
                            marginData: {
                                top: 12,
                                left: 12,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 15:
                    this.formData.push({
                        type: 15,
                        name: "质检报告",
                        content: {
                            height_id: 2,
                            title_color: "#00AC41",
                            title_size: "18",
                            title_bg_color: "#FFFFFF",
                            text_color: "#999999",
                            text_size: "12",
                            text_bg_color: "#FFFFFF",
                            marginData: {
                                top: 12,
                                left: 12,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 16:
                    this.formData.push({
                        type: 16,
                        name: "实例节点",
                        content: {
                            title_color: "#ffffff",
                            title_size: "18",
                            title_bg_color: "#00AC41",
                            text_color: "#666666",
                            text_size: "12",
                            text_bg_color: "#FFFFFF",
                            mode_id: "1",
                            line_color: "#D0D5EE",
                            circle_color: "#FF761D",
                            marginData: {
                                top: 12,
                                left: 12,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 17:
                    // 设置查询结果组件只push一次
                    var value;
                    value = this.formData.some((item) => item.type == 17);
                    if (value) {
                        return;
                    }
                    this.formData.push({
                        type: 17,
                        name: "查询结果",
                        content: {
                            title: "查询结果",
                            title_color: "#fff",
                            title_size: "18",
                            title_bg_color: "#00AC41",
                            text: "多次查询，请确保是您本人查询，防伪编码:xxx，您査询的是本公司正品，本次为第x次查询，首次查询时间：xxxx-xx-xx",
                            text_color: "#000000",
                            text_size: "14",
                            text_bg_color: "#fff",
                            marginData: {
                                left: 12,
                                top: 12,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 18:
                    this.formData.push({
                        type: 18,
                        name: "产品信息",
                        content: {
                            title: "产品信息",
                            title_color: "#00AC41",
                            title_size: "20",
                            title_bg_color: "#fff",
                            text: "xxx",
                            text_color: "#999999",
                            text_size: "14",
                            text_bg_color: "#fff",
                            marginData: {
                                left: 12,
                                top: 12,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                case 19:
                    this.formData.push({
                        type: 19,
                        name: "产品图片",
                        content: {
                            height_id: 1,
                            autoplay: "0",
                            time: 0,
                            imgList: [
                                {
                                    value: "/icon/diys/banner.png",
                                    picview:
                                        "https://suyuan.hulianzaowu.com/icon/diys/banner.png",
                                },
                            ],
                            marginData: {
                                top: 0,
                                left: 0,
                                topRadius: 0,
                                bottomRadius: 0,
                            },
                        },
                    });
                    break;
                default:
                    console.log("DIY");
                    break;
            }
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    margin-right: 50px;
    font-weight: 400;
    font-size: 16px;
    color: #484e66;
}
.flex-w {
    flex-wrap: wrap;
}
.card-btn {
    padding-left: 12px;
    margin: 6px 0;
    width: 130px;
    height: 42px;
    background: #ffffff;
    border: 1px solid #dce5eb;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
</style>